import { Fade } from 'react-awesome-reveal'
import PageWrapper from '@/components/page-wrapper'
import Styles from './style.module.scss'
import Banner from './banner'
import Highlights from './highlights'
import ProductSolution from './product-solution'
import Apart from './apart'
import News from './news'

const fadeProps = {
  cascade: true,
  triggerOnce: true,
  damping: 0.1,
}

export default function Index() {
  return (
    <PageWrapper soul className={Styles.homepage}>
      <Banner />
      <Fade {...fadeProps}>
        <Highlights />
        <ProductSolution />
        <Apart />
        <News />
      </Fade>
    </PageWrapper>
  )
}
